import { render, staticRenderFns } from "./VrsteSudionika.vue?vue&type=template&id=21868e6e&scoped=true&"
import script from "./VrsteSudionika.vue?vue&type=script&lang=js&"
export * from "./VrsteSudionika.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21868e6e",
  null
  
)

export default component.exports